export default "__VITE_ASSET__f2068d04__"